export const mockedFormatMessageI18n = ({ id }) => id;
export const mockedFormatDateI18n = (value) => value;
